import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  "aria-label": "Progress",
  class: "hidden min-w-full px-3 py-6 mt-8 bg-zinc-50 rounded-2xl profile-completion md:inline-block"
}
const _hoisted_2 = { class: "flex justify-between mb-1" }
const _hoisted_3 = { class: "text-base font-medium text-powder-800 dark:text-white" }
const _hoisted_4 = { class: "text-sm font-medium text-powder-800 dark:text-white" }
const _hoisted_5 = { class: "w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700" }
const _hoisted_6 = {
  key: 0,
  class: "pt-4 overflow-hidden",
  role: "list"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "flex items-center h-9" }
const _hoisted_9 = {
  key: 0,
  class: "relative z-10 flex items-center justify-center w-6 h-6 rounded-full bg-powder-500 group-hover:bg-powder-600"
}
const _hoisted_10 = {
  key: 1,
  class: "relative z-10 flex items-center justify-center w-6 h-6 text-gray-300 bg-white border rounded-full border-clay-500 group-hover:bg-powder-600 hover:text-white"
}
const _hoisted_11 = { class: "flex flex-col min-w-0 ml-4" }
const _hoisted_12 = { class: "my-1 font-medium text-md" }

import {computed, onMounted, Ref, ref} from "vue";
import {store} from "@/store";
import {CheckIcon, ChevronDownIcon, ChevronUpIcon, SparklesIcon} from '@heroicons/vue/20/solid';
import {client} from "@/shared";
import {GetUserMetadata, UserMetadata} from "@/dtos";
import _ from "lodash";



export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileProgress',
  setup(__props) {

// @ts-ignore


const tags = ref([]);
const sections = ref([]);
const openBrowseMore = ref(true);
const completedTags = computed(() => {
    let sectionTags: any[] = [];
    sections.value.forEach((section: any) => {
        sectionTags.push(section.tag);
    })
    let notCompleted = _.difference(sectionTags, tags.value).length;
    let completed = 7 - notCompleted;
    return completed;
});

const percentCompleted = computed(() => Math.floor((completedTags.value * 100) / 7));

onMounted(async () => {
    sections.value = store.profileProgressSection;

    await client.get<UserMetadata>(new GetUserMetadata())
        .then(response => {
            tags.value = response.tags
        });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "cursor-pointer",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (openBrowseMore.value =! openBrowseMore.value), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _cache[1] || (_cache[1] = _createTextVNode("Profile ")),
            _createVNode(_unref(ChevronDownIcon), { class: "inline-block w-5 h-5 hover:text-blue" })
          ]),
          _createElementVNode("span", _hoisted_4, _toDisplayString(percentCompleted.value) + "%", 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "bg-powder-600 h-2.5 rounded-full",
            style: _normalizeStyle({ width: percentCompleted.value + '%' })
          }, null, 4)
        ])
      ]),
      (openBrowseMore.value)
        ? (_openBlock(), _createElementBlock("ol", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections.value, (section) => {
              return (_openBlock(), _createElementBlock("li", {
                key: section.name,
                class: "relative pb-5"
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("div", {
                  "aria-hidden": "true",
                  class: "absolute top-4 left-3 -ml-px mt-0.5 h-full w-0.5 bg-gray-300 step-connect"
                }, null, -1)),
                _createElementVNode("a", {
                  href: section.url,
                  class: "relative flex items-start text-gray-700 group hover:text-powder-600"
                }, [
                  _createElementVNode("span", _hoisted_8, [
                    (tags.value.includes(section.tag))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                          _createVNode(_unref(CheckIcon), { class: "w-3 h-3 text-white" })
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, _cache[2] || (_cache[2] = [
                          _createElementVNode("span", { class: "bg-transparent rounded-full group-hover:bg-powder-600" }, null, -1)
                        ])))
                  ]),
                  _createElementVNode("span", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(section.name), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.actions, (action) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: action.name,
                        class: _normalizeClass([tags.value.includes(action.tag) ? 'text-powder-950   font-semibold' : 'text-powder-800', "text-sm"])
                      }, _toDisplayString(action.name), 3))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.actions, (action) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: action.name,
                        class: _normalizeClass([tags.value.includes(action.tag) ? 'text-powder-950  font-semibold' : 'text-powder-800  font-semibold', "text-sm"])
                      }, null, 2))
                    }), 128))
                  ])
                ], 8, _hoisted_7)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})